import axios from 'axios';
import Auth from '../utils/auth.js';
const isProd = window.location.href.includes('localhost') ? false : true;
const client = axios.create({
	baseURL: isProd
		? `${window.location.origin}/api`
		: 'http://localhost:5053/api',
	headers: {
		'Content-Type': 'application/json',
		Authorization: `Bearer ${Auth.getToken()}`,
	},
});
export default client;
